import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Button, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Select, TextField, FormControl, InputLabel, MenuItem, Grid, CircularProgress, Box } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import { BALANCE_RECORD_TYPES, BALANCE_RECORD_TYPE_MAP, PAY_METHOD_MAP } from "src/config/constants";
import { asyncRequest } from "src/services/network";
import UserInfo from "src/components/common/UserInfo";
import MerchantInfo from "src/components/common/MerchantInfo";
import MyDateRangePicker from "src/components/common/my-date-range-picker/MyDateRangePicker";
import MerchantPicker from "src/components/common/MerchantPicker";
import UserPicker from "src/components/common/UserPicker";

const types = Object.values(BALANCE_RECORD_TYPES);

const TABLE_HEAD = [
  { id: "sn", label: "流水号", alignRight: false },
  { id: "nickname", label: "用户", alignRight: false },
  { id: "category", label: "交易类型", alignRight: false },
  { id: "relation", label: "关联订单", alignRight: false },
  { id: "createdAt", label: "交易时间", alignRight: false },
  { id: "totalPrice", label: "订单金额", alignRight: false },
  { id: "payPrice", label: "实付金额", alignRight: false },
  // { id: "totalReward", label: "奖励", alignRight: false },
  { id: "totalRangli", label: "让利", alignRight: false },
  { id: "payMethod", label: "支付方式", alignRight: false },
  { id: "merchant", label: "商户", alignRight: false },
  { id: "remark", label: "备注", alignRight: false },
  { id: "操作" },
];

const moreMenus = [
  // { title: "编辑", icon: iconEdit2 }
];

export default function TransactionList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [merchant, setMerchant] = useState({});
  const [user, setUser] = useState({});
  const [items, setItems] = useState(null);
  const [total, setTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [stats, setStats] = useState({
    totalAmount: 0,
    totalReward: 0,
    totalRangli: 0,
  });

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
    isMer: 0,
    uid: "",
    mid: "",
    type: -1,
    createdAt: null,
  });

  useEffect(() => {
    setItems(null);
    setTotal(0);
    setTotalAmount(0);

    getItems();
    getTotalAmount();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/finance/transaction/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  async function getTotalAmount() {
    const { data } = await asyncRequest({
      path: "/finance/transaction/sum",
      data: filter,
    });

    setStats(data);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      page: 0,
      [ki]: val,
    });
  }

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      page: 0,
      search: event.target.value,
    });
  };

  function handleReset() {
    setFilter({
      page: 0,
      size: 10,
      search: "",
      uid: "",
      mid: "",
      relation: "",
      type: -1,
      createdAt: null,
    });
    setMerchant({});
    setUser({});
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`/user/detail/${row.uid}`);
    }
  };

  function handleSelectMerchant() {
    MerchantPicker({
      onSelect(val) {
        console.log(val, val.mid);
        setMerchant(val);
        handleFilterChange("mid", val.mid);
      },
    });
  }

  function handleSelectUser() {
    UserPicker({
      onSelect(val) {
        setUser(val);
        handleFilterChange("uid", val.uid);
      },
    });
  }

  async function handleExport() {
    const { data, msg } = await asyncRequest({
      path: "/finance/transaction/export",
      data: filter,
    });

    alert(msg, "success");
  }

  // const emptyRows = filter.size - items.length;
  const isUserNotFound = items && items.length === 0;

  return (
    <Page title="流水明细">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            流水明细
          </Typography>
        </Stack>

        <Card>
          <ListToolbar
            showSearch={false}
            filterName={filter.search}
            onFilterName={handleFilterByName}
            onReset={handleReset}
            onRefresh={() => {
              getItems();
              getTotalAmount();
            }}
            onExport={handleExport}
          >
            <Grid container rowGap={2}>
              <Grid item lg={6} sm={6} md={3}>
                <MyDateRangePicker
                  value={filter.createdAt}
                  onChange={(val) => {
                    setFilter({
                      ...filter,
                      createdAt: val,
                    });
                  }}
                />
              </Grid>

              <Grid item sm={6} md={3}>
                {/* <TextField
                  size="small"
                  style={{ width: 200 }}
                  label="商户ID"
                  placeholder="商户ID"
                  autoComplete="off"
                  id="mid"
                  value={filter.mid}
                  onChange={(e) => {
                    handleFilterChange("mid", e.target.value);
                  }}
                /> */}
                <TextField fullWidth placeholder="选择商户" autoComplete="off" id="merchant" value={merchant.name || ""} size="small" onClick={() => handleSelectMerchant()} />
              </Grid>

              <Grid item sm={6} md={3}>
                {/* <TextField
                  size="small"
                  style={{ width: 200 }}
                  label="用户ID"
                  placeholder="用户ID"
                  autoComplete="off"
                  id="uid"
                  value={filter.uid}
                  onChange={(e) => {
                    handleFilterChange("uid", e.target.value);
                  }}
                /> */}
                <TextField fullWidth placeholder="选择用户" autoComplete="off" id="user" value={user.mobile || ""} size="small" onClick={() => handleSelectUser()} />
              </Grid>

              <Grid item sm={6} md={3}>
                <TextField
                  size="small"
                  style={{ width: 200 }}
                  label="订单号"
                  placeholder="订单号"
                  autoComplete="off"
                  id="relation"
                  value={filter.relation}
                  onChange={(e) => {
                    handleFilterChange("relation", e.target.value);
                  }}
                />
              </Grid>
              {/*               
              <Grid item sm={6} md={3}>
                <FormControl size="small">
                  <InputLabel>类型</InputLabel>
                  <Select
                    label="类型"
                    value={filter.type}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        type: e.target.value,
                      });
                    }}
                    style={{ width: 250 }}
                  >
                    {[-1, ...types].map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {idx == 0 ? "全部" : BALANCE_RECORD_TYPE_MAP[type]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}

              {/* <Grid item sm={6} md={3}>
                <FormControl
                  size="small">
                  <InputLabel>用户/商家</InputLabel>
                  <Select
                    label="用户/商家"
                    value={filter.isMer}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        isMer: e.target.value,
                      });
                    }}
                    style={{ width: 250 }}
                  >
                    {[0, 1].map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {["用户", "商家"][type]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}
            </Grid>
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                {filter.type != -1 && (
                  <TableRow>
                    <TableCell>
                      <Stack>
                        <Typography>总数额：{totalAmount}元</Typography>
                      </Stack>
                    </TableCell>
                  </TableRow>
                )}

                <ListHead headLabel={TABLE_HEAD} />
                {!items ? (
                  <Stack sx={{ width: 500, height: 200 }} alignItems="center" justifyContent="center">
                    <CircularProgress />
                  </Stack>
                ) : (
                  <TableBody>
                    {items.map((row) => {
                      const { id, sn, user, merchant, realname, category, orderSN, createdAt, remark, payMethod, rangli, totalPrice, payPrice } = row;
                      const isItemSelected = selected.indexOf(realname) !== -1;

                      return (
                        <TableRow hover key={id} tabIndex={-1} role="checkbox">
                          <TableCell align="left">{sn}</TableCell>
                          <TableCell component="th" scope="row">
                            {user ? <UserInfo {...user} enablePreview /> : null}
                          </TableCell>
                          <TableCell align="left">{category == 1 ? "线下订单" : "线上订单"}</TableCell>
                          <TableCell align="left">{orderSN}</TableCell>
                          <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                          <TableCell align="left">{totalPrice}</TableCell>
                          <TableCell align="left">{payPrice}</TableCell>
                          <TableCell align="left">{rangli}</TableCell>
                          <TableCell align="left"> {PAY_METHOD_MAP[payMethod]}</TableCell>
                          <TableCell component="th" scope="row">
                            {merchant ? <MerchantInfo enablePreview {...merchant} /> : null}
                          </TableCell>
                          <TableCell align="left">{remark}</TableCell>
                          <TableCell align="right">
                            <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {/* {emptyRows > 0 && (
                      <TableRow style={{ height: 50 * emptyRows }}>
                        <TableCell colSpan={2} />
                      </TableRow>
                    )} */}
                    <TableRow>
                      {/* <TableCell rowSpan={3} /> */}
                      <TableCell colSpan={1}>总营收：{stats.totalAmount.toFixed(2)}</TableCell>
                      <TableCell colSpan={1}>总让利：{stats.totalRangli.toFixed(2)}</TableCell>
                      {/* <TableCell colSpan={1}>总利润：{(stats.totalAmount - stats.totalRangli).toFixed(2)}</TableCell> */}
                      {/* <TableCell align="right"></TableCell> */}
                    </TableRow>
                  </TableBody>
                )}

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>
    </Page>
  );
}
